import { TESTIDS } from "@/lib/testids";

export default function AdminLayout({ header, pageHeader, children }) {
  return (
    <div className="flex h-full min-h-0 flex-col" data-testid={TESTIDS.adminLayout.root}>
      {header ? (
        <div
          className="border-b border-white/10 bg-slate-900/80 backdrop-blur"
          data-testid={TESTIDS.adminLayout.globalHeader}
        >
          {header}
        </div>
      ) : null}

      {pageHeader ? (
        <div
          className="border-b border-white/5 bg-slate-900/50"
          data-testid={TESTIDS.adminLayout.pageHeader}
        >
          {pageHeader}
        </div>
      ) : null}

      <div className="min-h-0 flex-1 overflow-y-auto" data-testid={TESTIDS.adminLayout.scrollContent}>
        <div className="mx-auto w-full max-w-7xl px-6 py-6">{children}</div>
      </div>
    </div>
  );
}
